// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"95270e2b","215":"0e44d420"}[chunkId] + ".chunk.js";
};